<template>
  <div>
    <!-- 헤더 -->
    <header class="topbar">
      <AppLogo asLink to="/" :height="22" />
    </header>

    <!-- 메인 카드 -->
    <main class="main">
      <div class="container">
        <div class="card auth-card">
          <div class="auth-inner">
            <slot />
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import AppLogo from "@/components/AppLogo.vue";

export default {
  name: "AuthLayout",
  components: { AppLogo },
};
</script>

<style scoped>
/* 헤더 */
.topbar {
  height: 56px; /* ← 70px → 56px (피그마 기준) */
  display: flex;
  align-items: center;
  padding: 0 20px; /* ← 24px → 20px */
  position: relative;
  z-index: 100;
}

/* 메인 영역 */
.main {
  margin-top: 100; /* ← 190px(카드 top) - 56px(헤더) = 134px */
  padding: 0 20px 40px 20px;
  min-height: calc(100vh - 56px);
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

.container {
  width: 100%;
  max-width: 353px; /* ← 500px → 353px (피그마 기준) */
  margin: 0 auto;
}

/* 인증 카드 */
.auth-card {
  background: #151718;
  border-radius: 20px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.35);
  position: relative;
  z-index: 10;
  width: 100%;
  min-height: 457px; /* ← 피그마 높이 */
  padding: 0;
  overflow: hidden;
}

.auth-inner {
  padding: 30px; /* ← 40px → 30px (피그마 내부 여백) */
  width: 100%;
  box-sizing: border-box;
}

/* 태블릿 이상 - 좀 더 여유있게 */
@media (min-width: 641px) {
  .topbar {
    height: 70px;
    padding: 0 24px;
  }

  .main {
    margin-top: 200px;
  }

  .container {
    max-width: 500px;
  }

  .auth-inner {
    padding: 40px;
  }
}

/* 모바일 반응형 */
@media (max-width: 640px) {
  .main {
    margin-top: 100px;
    padding: 0 20px 40px 20px;
  }

  .auth-card {
    border-radius: 20px; /* 그대로 유지 */
  }

  .auth-inner {
    padding: 30px;
  }
}

@media (max-width: 480px) {
  .auth-inner {
    padding: 25px 20px; /* 더 작은 화면용 */
  }
}
</style>
